import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(n,t)}const n=e=>e.at(-1);export{t as last};
//# sourceMappingURL=last-BAoGYmhs.js.map